import { useEffect, useState } from 'react';
import { identity } from 'ramda';
import { get } from 'js/utils/fetch.util';
import { useDispatch } from 'react-redux';
import { useDataFetch } from 'js/hooks/useDataFetch';
import { useGetCMSResourceURL } from 'js/hooks/useGetCMSResourceURL';

import * as helpers from './helpers';
import * as actions from '../../store/actions';

export const usePlaytechVariables = () => {
    const dispatch = useDispatch();
    const getCMSResourceURL = useGetCMSResourceURL();
    const [isWindowVariablesUpdated, setIsWindowVariablesUpdated] = useState(false);
    const [{ isLoading, error, data: variables }, refetch] = useDataFetch({
        fetch: get,
        shouldFetch: identity,
        initialIsLoading: false,
        onResponse: helpers.onResponseHandler
    });

    useEffect(() => {
        if (!variables) {
            return;
        }

        window.Playtech = window.Playtech || {};
        window.Playtech.Variables = { ...window.Playtech.Variables, ...variables };

        dispatch(actions.fetchApp({
            app: { ...window.Playtech.Variables, ...variables },
            areInitialResourcesLoaded: true
        }));

        setIsWindowVariablesUpdated(true);
    }, [variables, setIsWindowVariablesUpdated, dispatch]);

    useEffect(() => {
        if (!variables && !error && !isLoading) {
            refetch(getCMSResourceURL('/initialResources/portal', { t: Date.now() }));
        }
    }, [getCMSResourceURL, isLoading, variables, error, refetch]);

    return [{ isLoading: !isWindowVariablesUpdated || isLoading, error, variables }, refetch];
};
